(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cv-hero-search"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // Palabra rotativa del titular con icono acorde: herramientas(llave) → maquinaria(excavadora) → andamios → hostelería(copa) → material(ladrillos)
    var ICONS={
      'herramientas':'<svg viewBox="0 0 24 24" fill="none"><path d="M14.5 5.5a3.5 3.5 0 0 0-4.6 4.3L3.7 16a1.6 1.6 0 0 0 2.3 2.3l6.2-6.2a3.5 3.5 0 0 0 4.3-4.6l-2.1 2.1-2.1-.5-.5-2.1 2.1-2.1Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
      'maquinaria':'<svg viewBox="0 0 24 24" fill="none"><path d="M3 18h13l-2-4h-4V9l7 3 2 6M3 18l1-3h4M3 18h16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7" cy="20" r="1.6" stroke="currentColor" stroke-width="1.6"/><circle cx="17" cy="20" r="1.6" stroke="currentColor" stroke-width="1.6"/></svg>',
      'andamios':'<svg viewBox="0 0 24 24" fill="none"><path d="M4 4v16M20 4v16M4 9h16M4 15h16M9 4v16M15 4v16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
      'equipos de hostelería':'<svg viewBox="0 0 24 24" fill="none"><path d="M6 3h12l-1 6a5 5 0 0 1-10 0L6 3ZM12 14v5M8 21h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      'material de obra':'<svg viewBox="0 0 24 24" fill="none"><path d="M3 9h8V5H3v4ZM13 9h8V5h-8v4ZM3 15h8v-4H3v4ZM13 15h8v-4h-8v4ZM8 19h8v-4H8v4Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>'
    };
    var rot=document.querySelector('[data-cvh-rot]');
    var wrap=document.querySelector('[data-cvh-rotwrap]');
    var iconEl=document.querySelector('[data-cvh-rot-icon]');
    function setIcon(w){ if(iconEl) iconEl.innerHTML=ICONS[w]||ICONS['herramientas']; }
    if(rot){
      var words=(rot.getAttribute('data-words')||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
      setIcon(words[0]);
      if(words.length>1){
        var i=0, reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setInterval(function(){
          i=(i+1)%words.length;
          if(reduce){ rot.textContent=words[i]; setIcon(words[i]); return; }
          if(wrap) wrap.classList.add('is-out');
          setTimeout(function(){ rot.textContent=words[i]; setIcon(words[i]); if(wrap) wrap.classList.remove('is-out'); },260);
        }, 2400);
      }
    }

    var root=document.querySelector('[data-cvh-search]'); if(!root) return;
    var tabs=root.querySelectorAll('[data-cvh-tab]');
    var panels=root.querySelectorAll('[data-cvh-panel]');
    tabs.forEach(function(t){
      t.addEventListener('click',function(){
        var key=t.getAttribute('data-cvh-tab');
        tabs.forEach(function(x){var on=x===t;x.classList.toggle('is-active',on);x.setAttribute('aria-selected',on?'true':'false');});
        panels.forEach(function(p){var on=p.getAttribute('data-cvh-panel')===key;p.classList.toggle('is-active',on);p.hidden=!on;});
      });
    });

    function enc(s){return encodeURIComponent((s||'').trim());}

    // Comprar: hay término → /search?q=; solo categoría → /collections/<handle>
    var buy=root.querySelector('[data-cvh-panel="buy"]');
    buy.addEventListener('submit',function(e){
      var q=root.querySelector('[data-cvh-buy-q]').value.trim();
      var cat=root.querySelector('[data-cvh-buy-cat]').value;
      if(!q && cat){ e.preventDefault(); window.location.href='/collections/'+cat; }
      else if(q && cat){ e.preventDefault(); window.location.href='/collections/'+cat+'?q='+enc(q)+'&type=product'; }
      // si solo q: deja el submit nativo del form (/search?q=)
    });

    // Alquilar: ciudad → /pages/alquiler-<slug> (+q); sin ciudad → /pages/alquiler
    var rent=root.querySelector('[data-cvh-panel="rent"]');
    rent.addEventListener('submit',function(e){
      e.preventDefault();
      var city=root.querySelector('[data-cvh-rent-city]').value;
      var q=root.querySelector('[data-cvh-rent-q]').value.trim();
      var url=city?('/pages/alquiler-'+city):'/pages/alquiler';
      if(q) url+='?q='+enc(q);
      window.location.href=url;
    });
    // Vender: submit nativo → /pages/vende-la-tuya?q=
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-provider"]) return;
  try {
    
  (function(){
    var f=document.querySelector('[data-cvpr-form]'); if(!f) return;
    f.addEventListener('submit',function(e){
      e.preventDefault();
      if(f.querySelector('.cvpr-hp')&&f.querySelector('.cvpr-hp').value) return;
      var g=function(n){var el=f.querySelector('[name="'+n+'"]');return el?el.value.trim():'';};
      var payload={name:g('name'),phone:g('phone'),email:g('email'),city:g('city'),message:'[PROVEEDOR] '+g('message'),origen:'herramientasusadas-proveedor'};
      fetch('https://mpb-scraper-production.up.railway.app/api/fillout/hu-contact-lead',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),keepalive:true}).catch(function(){});
      var ok=f.querySelector('[data-cvpr-ok]'); if(ok) ok.hidden=false;
      f.querySelectorAll('input,textarea,button').forEach(function(el){el.disabled=true;});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
